import { Box } from '@chakra-ui/react'
import type React from 'react'
import { StepNavigatorItem, StepNavigatorItemStatus } from './StepNavigatorItem'
import type { StepNavigatorItemProps } from './StepNavigatorItem'

export interface StepNavigatorProps {
  items: StepNavigatorItemProps[]
  minHeight?: string
  paddingLeft?: number
}

export const StepNavigator: React.FC<StepNavigatorProps> = ({
  items,
  minHeight = '48px',
  paddingLeft = 3,
}) => (
  <Box
    minH={minHeight}
    display="flex"
    flexDirection="column"
    justifyContent="start"
    paddingLeft={paddingLeft}
  >
    {items.map((item) => (
      <StepNavigatorItem key={item.label} {...item} />
    ))}
  </Box>
)

export { StepNavigatorItemStatus }
